module.exports = __webpack_public_path__ + "img/icon-helmet.02daf461.svg";